import { useAppSelector } from 'store/hooks';
import { getDirection, isRtlLanguage } from 'utils/direction';

export const useDirection = () => {
  const { currentLanguage } = useAppSelector((state) => state.global);

  return {
    direction: getDirection(currentLanguage),
    isRtl: isRtlLanguage(currentLanguage),
  };
};